"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadingCol = exports.Header = exports.CloseIcon = exports.CloseCol = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icons = require("../Icons");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var HeadingCol = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeadingCol",
  componentId: "sc-1ynsbrb-0"
})(["flex-grow:1;"]);
exports.HeadingCol = HeadingCol;
var CloseCol = _styledComponents["default"].div.withConfig({
  displayName: "styles__CloseCol",
  componentId: "sc-1ynsbrb-1"
})(["&:focus{border-width:1px;border-style:solid;border-color:lightgray;}"]);
exports.CloseCol = CloseCol;
var CloseIcon = (0, _styledComponents["default"])(_Icons.X).attrs({
  role: 'button'
}).withConfig({
  displayName: "styles__CloseIcon",
  componentId: "sc-1ynsbrb-2"
})(["cursor:pointer;"]);
exports.CloseIcon = CloseIcon;
var Header = _styledComponents["default"].div.withConfig({
  displayName: "styles__Header",
  componentId: "sc-1ynsbrb-3"
})(["display:flex;flex-direction:row;& > div{padding:10px;}", " ", ""], function (props) {
  return props.bordered && (0, _styledComponents.css)(["border-bottom:2px solid #eee;"]);
}, function (props) {
  return props.centered && (0, _styledComponents.css)(["", ",", "{display:flex;align-items:center;}"], HeadingCol, CloseCol);
});
exports.Header = Header;
//# sourceMappingURL=styles.js.map